import React, { useEffect, useState } from "react";

import { useCloudFileApi } from "../../../../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { GetRekognitionResultResponse } from "../../../../../../../../common/api/master-api/qc/GetRekognitionResultByIdResponse";
import { RekognitionResultItem, mapToRekognitionResultItem } from "../listing/RekognitionResultItem";
import { VideoRekognitionResultContext } from "./VideoRekognitionResultContext";

type VideoRekognitionResultProviderProps = { cloudFileId: string };

export const VideoRekognitionResultProvider: React.FC<VideoRekognitionResultProviderProps> = ({
    cloudFileId,
    children
}) => {
    const { getRekognitionResult } = useCloudFileApi();

    const [items, setItems] = useState<RekognitionResultItem[]>([]);
    const [selectedItems, setSelectedItems] = useState<RekognitionResultItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);

        getRekognitionResult({ cloudFileId })
            .then((response: GetRekognitionResultResponse) => {
                const mappedItems = response.items.map(mapToRekognitionResultItem);

                setItems(mappedItems);
                setSelectedItems(mappedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const updateItem = (key: string, startTimestamp: number, endTimestamp: number): void => {
        setItems((prevItems) => {
            const segmentToEdit = prevItems.find((segment) => segment.key === key);

            if (!segmentToEdit) return prevItems;

            segmentToEdit.startTimestamp = startTimestamp;
            segmentToEdit.endTimestamp = endTimestamp;

            return [...prevItems];
        });
    };

    const showRekognitionPreview = !!items.length;

    return (
        <VideoRekognitionResultContext.Provider
            value={{
                cloudFileId,
                items,
                setItems,
                selectedItems,
                setSelectedItems,
                isLoading,
                updateItem,
                showRekognitionPreview
            }}
        >
            {children}
        </VideoRekognitionResultContext.Provider>
    );
};
